import * as React from "react";
import { DefaultButton, IButtonStyles } from "@fluentui/react/lib/Button";
import { Modal } from "@fluentui/react";
import { IPersonaProps, Persona } from "@fluentui/react/lib/Persona";
import {
  ITag,
  NormalPeoplePicker,
  IBasePickerSuggestionsProps,
} from "@fluentui/react/lib/Pickers";
import _ from "lodash";
import {
  getTeamMemberList,
  getMemberSearchList,
} from "../../services/teamssearch.sevice";
import { app } from "@microsoft/teams-js";
import { useState, useEffect, useContext } from "react";
import { useTeams } from "msteams-react-base-component";
import { useHistory, useLocation } from "react-router-dom";
import { Provider } from "@fluentui/react-northstar";
import { AppCtx } from "../common/context";
import { Text, ITextProps } from "@fluentui/react/lib/Text";
import { TooltipHost, ITooltipHostStyles } from "@fluentui/react/lib/Tooltip";
import {
  ChevronStartIcon
} from "@fluentui/react-icons-northstar";
import { Button, Flex, Card } from "@fluentui/react-northstar";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import { useDispatch, useSelector } from "react-redux";
import TextContent from "../common/Text";
import { refreshTokenGenerator } from "../../services/auth.service";
import {
  saveRecipient,
  saveBehaviorInfo,
  saveCustomImageInfo,
  setCheckboxPrivate,
  saveTeamMemberList,
  saveFilters,
  saveCopyOthersRecipient,
  removeCopyOthersRecipient,
  selectedParticipantId,
  setCopyManager,
  setCopyMe,
  restoreCopyOthersEmail
} from "../../action/actionCreators";
import { motion } from "framer-motion";
import { pageVariants } from "../common/utils";
import { useTranslation } from "react-i18next";
import AdvancedFilter from "./advancedSearch";

const defaultButtonStyles: Partial<IButtonStyles> = {
  root: {
    height: "auto",
    backgroundColor: "Transparent",
    backgroundRepeat: "no-repeat",
    border: "none",
    cursor: "pointer",
    overflow: "hidden",
    outline: "none",
    margin: "5px 0px",
  },
};

const PeoplePickerControlledExample = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isModalOpen, showModal] = React.useState(false);
  const [delayResults, setDelayResults] = React.useState(false);
  const [isPickerDisabled, setIsPickerDisabled] = React.useState(false);
  const [peopleList, setPeopleList] = useState([]);
  const picker = React.useRef<any>(null);
  const [{ inTeams, theme }] = useTeams();
  const [token, setToken] = useState<any>(null);
  const [searchResult, setSearchApiResult] = useState([]);
  const loginToken = useContext(AppCtx);
  const promotion = useSelector((data: any) => data.commonReducer.promotion);
  const recipients = useSelector((data: any) => data.commonReducer.recepients);
  const copyrecipients = useSelector((data: any) => data.commonReducer.copyOthersRecepients);
  const state = useSelector((data: any) => data.commonReducer);
  const [filters, setFilters] = React.useState({});
  const [filterKey, setFilterKey] = React.useState("");
  const [copyothers, setCopyothers] = useState(false);
  const [copyOthersSelectedItem, setCopyOthersSelectedItem] = useState(copyrecipients ? copyrecipients : []);
  const [recognitionComponent, setRecognitionComponent] = useState(true);
  const [copyOthersChange, setCopyOthersChange] = useState(false);
  const [copyOthersUpdate, setCopyOthersUpdate] = useState(false);
  // const promoList = useSelector(
  //   (state: any) => state.commonReducer.selectedAllPromotions
  // );
  const [currentSelectedItems, setCurrentSelectedItems] = useState(
    recipients ? recipients : []
  );
  const { t, i18n } = useTranslation();

  const history = useHistory();
  // tslint:disable: no-shadowed-variable
  const getTextFromItem = (item: ITag) => item.name;
  const numberPoints = useSelector((state: any) => state.commonReducer);
  useEffect(() => {
    if (localStorage.getItem("token")) {
      setToken(localStorage.getItem("token"));
    }
    if (inTeams === true) {
      app.notifySuccess();
    }
  }, [inTeams]);

  useEffect(() => {
    if (location?.state?.copyothers) {
      setCopyothers(true);
      setRecognitionComponent(false);
      picker.current.input.current._updateValue(location?.state?.copySearchValue);
      picker.current.focus();
    }
    const getPromotions = async () => {
      initializeIcons();
      // tslint:disable: no-shadowed-variable
      const token = loginToken;
      const result = await getTeamMemberList(token, promotion.id);
      dispatch(saveTeamMemberList(result.data.participants));
      if (!location?.state?.copyothers) {
        const promotionText = onListTextChanges(result.data.participants);
        const difference = _.differenceBy(
          promotionText,
          currentSelectedItems,
          "key"
        );
        setPeopleList(difference);
      } else {
        const arr = [...copyOthersSelectedItem, ...currentSelectedItems];
        const promotionText = onListTextChanges(result.data.participants);
        const difference = _.differenceBy(
          promotionText,
          arr,
          "key"
        );
        setPeopleList(difference);
      }

    };
    getPromotions();
  }, []);
  useEffect(() => {
    setFilters(state.filters);
  }, [state.filters]);

  async function getSearchList(searchData) {
    const recipientsId = state.participantIds;
    const result = await getMemberSearchList(promotion.id, searchData, filters, recipientsId);
    if (result.status === 200) {
      const promotionText = onListTextChanges(result.data.participants);

      setSearchApiResult(promotionText);
      return promotionText;
    } else {
      // tslint:disable: no-shadowed-variable
      const token = localStorage.getItem("appToken");
      refreshToken(token, searchData);
    }
  }
  // tslint:disable: no-shadowed-variable
  const refreshToken = async (token, searchData) => {
    const tokenResponse = await refreshTokenGenerator(token);
    if (tokenResponse.status === 200) {
      localStorage.setItem("appToken", tokenResponse.data.token);
      getSearchList(searchData);
    }
  };

  const onListTextChanges = (data) => {
    const result = data.map((val) => {
      return {
        key: val.id,
        node: val.nodes[0].id,
        imageUrl: val.avatarUrl ? val.avatarUrl : null,
        text: val.firstName + " " + val.lastName,
        email: val?.emailAddress ? val?.emailAddress : "",
        secondaryText: (
          <div className="bit_list_grid">
            <TextContent className="bit_text_14" content={val.emailAddress} />
            <TextContent
              className="bit_text_14"
              content={`${val.jobName}, ${val.departmentName}, ${val.orgName
                }, ${_.upperCase(val.countryCode)}`}
            />
          </div>
        ),
        tertiaryText: `${val.jobName}, ${val.departmentName}, ${val.orgName
          }, ${_.upperCase(val.countryCode)}`,
        optionalText: val.departmentName,
        isValid: true,
        countryCode: val.countryCode,
        countryRatio: val.countryRatio,
        countryName: val.countryName,
        optOutAwards: val.optOutAwards,
      };
    });
    return result;
  };

  const setPickerFocus = () => {
    if (picker.current) {
      // console.log(filterKey);
      picker.current.input.current._updateValue(filterKey);
    }
  };

  const onFilterChanged = async (
    filterText: string,
    currentPersonas: IPersonaProps[],
    limitResults?: number
  ) => {
    if (filterText) {
      setFilterKey(filterText);
      let filteredPersonas = await filterPersonasByText(filterText);
      filteredPersonas = removeDuplicates(filteredPersonas, currentPersonas);
      filteredPersonas = limitResults
        ? filteredPersonas.slice(0, limitResults)
        : filteredPersonas;
      return filterPromise(filteredPersonas);
    } else {
      return [];
    }
  };

  const onFilterChangedFilter = async (
    filterText: string,
    currentPersonas: IPersonaProps[],
    limitResults?: number
  ) => {
    if (filterText) {
      setFilterKey(filterText);
      // console.log('Filter Text', filterText);
      let filteredPersonas = await filterPersonasByText(filterText);
      filteredPersonas = removeDuplicates(filteredPersonas, currentPersonas);
      filteredPersonas = limitResults
        ? filteredPersonas.slice(0, limitResults)
        : filteredPersonas;
      return filterPromise(filteredPersonas);
    } else {
      return [];
    }
  };

  const filterPersonasByText = async (filterText: string) => {
    const data = await getSearchList(filterText);
    return data.filter((item) => {
      return item;
    });
  };

  const filterPromise = (
    personasToReturn: IPersonaProps[]
  ): IPersonaProps[] | Promise<IPersonaProps[]> => {
    if (delayResults) {
      return convertResultsToPromise(personasToReturn);
    } else {
      return personasToReturn;
    }
  };

  const onItemsChange = async (items: any[]) => {
    dispatch(removeCopyOthersRecipient(items));
    dispatch(saveRecipient(items));
    for (const item of items) {
      dispatch(selectedParticipantId(item.key));
    }
    setCurrentSelectedItems(items);
    const promotionText = onListTextChanges(state.teamMemberList);
    const difference = _.differenceBy(promotionText, items, "key");
    setPeopleList(difference);
  };
  const onCopyOthersChange = async (items: any[]) => {
    setCopyOthersSelectedItem(items);
    const promotionText = onListTextChanges(state.teamMemberList);
    const res = [...items, ...currentSelectedItems];
    const difference = _.differenceBy(promotionText, res, "key");
    setPeopleList(difference);
  };

  const controlledItems = [] as any;
  for (const i in peopleList) {
    if (peopleList && peopleList.length > 0) {
      const item = peopleList[i];
      if (!copyothers) {
        if (currentSelectedItems!.indexOf(item) === -1) {
          controlledItems.push(peopleList[i]);

        }
      }
      if (location?.state?.copyothers) {
        if (copyOthersSelectedItem!.indexOf(item) === -1) {
          controlledItems.push(peopleList[i]);
        }
      }
    }
  }
  useEffect(() => {
    const arr: any = [];
    for (const item of currentSelectedItems) {
      arr.push(item.key);
      dispatch(removeCopyOthersRecipient(item));
    }
    dispatch(selectedParticipantId(arr));
  }, [currentSelectedItems]);
  const goBack = () => {
    dispatch(saveRecipient([]));
    dispatch(saveBehaviorInfo({}));
    dispatch(saveCustomImageInfo({}));
    dispatch(setCheckboxPrivate(false));
    dispatch(saveCopyOthersRecipient([]));
    dispatch(setCopyManager(false));
    dispatch(setCopyMe(false));
    dispatch(
      saveFilters({
        jobTitle: "",
        department: "",
        location: "",
        country: "",
        group: "",
      })
    );
    const appToken = localStorage.getItem("appToken");
    const host = localStorage.getItem("host");
    const context = localStorage.getItem("context");
    history.push({
      pathname: `/promotions/${appToken}/${host}/${context}`,
    });
  };
  const gotoRecipient = () => {
    if (promotion.awardAvailable) {
      history.push({
        pathname: "/addrecipients",
      });
    } else {
      history.push({
        pathname: "/addbehaviours",
      });
    }
  };

  const copyOthersAdding = (val) => {
    if (val === "add") {
      dispatch(saveCopyOthersRecipient(copyOthersSelectedItem));
    }
    history.push({
      pathname: "/addbehaviours",
      state: { scrollDown: true }
    });
  };

  const suggestionProps: IBasePickerSuggestionsProps = {
    suggestionsHeaderText: t("Participants.SuggestionsHeaderText"),
    mostRecentlyUsedHeaderText: "Suggested Contacts",
    noResultsFoundText: t("Participants.NoResultsFoundText"),
    loadingText: t("Participants.LoadingText"),
    showRemoveButtons: true,
    suggestionsAvailableAlertText: "People Picker Suggestions available",
    suggestionsContainerAriaLabel: "Suggested contacts",
  };

  const hostStyles: Partial<ITooltipHostStyles> = {
    root: { display: "flex", justifyContent: "flex-end" },
  };

  const hostStyles1: Partial<ITooltipHostStyles> = {};

  return (
    <motion.div initial="out" animate="in" exit="out" variants={pageVariants}>
      <Provider
        theme={theme}
        className={`promoProvider paxSearchProvider appProvider`}
      >
        <Modal
          isOpen={isModalOpen}
          // onDismiss={hideModal}
          isBlocking={false}
        >
          <AdvancedFilter isModalOpen={isModalOpen} showModal={showModal} filterReference={setPickerFocus} />
        </Modal>
      </Provider>
      {recognitionComponent ?
        <Provider
          theme={theme}
          className={`promoProvider paxSearchProvider appProvider`}
        >
          <Flex
            fill={true}
            column
            className="promoAppWrapper bg-none"
            style={{ paddingTop: "1%" }}
          >
            <Card>
              <div>
                {recognitionComponent ?
                  <Text
                    className="bit_text_14 bit_text_normal bit_text_upper"
                    key={"xLarge"}
                    variant={"xLarge" as ITextProps["variant"]}
                    nowrap
                    block
                  >
                    {currentSelectedItems.length > 0
                      ? currentSelectedItems.length === 1
                        ? `${currentSelectedItems.length} ${t(
                          "Participants.Recipient"
                        )}`
                        : `${currentSelectedItems.length} ${t(
                          "Participants.Recipients"
                        )}`
                      : `0 ${t("Participants.Recipient")}`}
                  </Text> : null}
                {recognitionComponent ?
                  <Text
                    className="bit_text_20 bit_text_bold bit_titleSpace"
                    key={"xLarge"}
                    variant={"xLarge" as ITextProps["variant"]}
                    nowrap
                    block
                  >
                    {`${t("Participants.Header")}`}
                  </Text> :
                  <Text
                    className="bit_text_20 bit_text_bold bit_titleSpace"
                    key={"xLarge"}
                    variant={"xLarge" as ITextProps["variant"]}
                    nowrap
                    block
                  >
                    {t("Behavior.CopyOthersHeader")}
                  </Text>}
                <div>
                  <div
                    className={`filter-icon ${filters && getFilterCount(filters) > 0
                      ? "advanced-filter-count-bg"
                      : ""
                      }`}
                    onClick={() => showModal(!isModalOpen)}
                  >
                    {filters && getFilterCount(filters) > 0 && (
                      <label>{getFilterCount(filters)}</label>
                    )}
                    <TooltipHost
                      content={t("Participants.AdvancedFilter.Filters")}
                      id={"tooltipId"}
                      calloutProps={{ gapSpace: 0 }}
                      styles={
                        filters && getFilterCount(filters) > 0
                          ? hostStyles1
                          : hostStyles
                      }
                    >
                      <div
                        className={`advanceFilter-icon-svg ${filters && getFilterCount(filters) > 0
                          ? "advanced-filter-white-icon"
                          : ""
                          }`}
                      ></div>
                    </TooltipHost>
                  </div>
                  <NormalPeoplePicker
                    onResolveSuggestions={onFilterChanged}
                    getTextFromItem={getTextFromItem}
                    pickerSuggestionsProps={suggestionProps}
                    className={"ms-PeoplePicker ms-Suggestions"}
                    key={"controlled"}
                    selectionAriaLabel={"Selected contacts"}
                    removeButtonAriaLabel="Remove"
                    selectedItems={currentSelectedItems}
                    onChange={onItemsChange}
                    inputProps={{
                      "aria-label": "Contacts",
                      "className": "ms-Suggestions max-width-list",
                      "placeholder": `${t("Participants.PlaceHolder")}`,
                      "onFocus": (ev: React.FocusEvent<HTMLInputElement>) => {
                        // console.log("onFocus called...", filterKey);
                        filterPersonasByText(filterKey);
                      },
                    }}
                    componentRef={picker}
                    resolveDelay={300}
                    disabled={isPickerDisabled}
                  />
                  <label className="label_gray">
                    {`${t("Participants.SubHeader")}`}
                  </label>
                  <section className="paxDefaultList">
                    {controlledItems.map((item, index) => (
                      <div key={index}>
                        <DefaultButton
                          styles={defaultButtonStyles}
                          onClick={() => {
                            setCurrentSelectedItems(
                              currentSelectedItems.concat([item])
                            );
                            dispatch(
                              saveRecipient(currentSelectedItems.concat([item]))

                            );
                          }}
                        >
                          <Persona {...item} />
                        </DefaultButton>
                      </div>
                    ))}
                  </section>
                </div>
              </div>
              <div className="footer">
                <Flex space="between">
                  <Button
                    icon={<ChevronStartIcon size="large" />}
                    tinted
                    iconOnly
                    title={`${t("Participants.Back")}`}
                    content={`${t("Participants.Back")}`}
                    onClick={goBack}
                    className="mg-l-5 bit-pad-10"
                    style={{ border: "1px #6264a7 solid" }}
                    size="medium"
                  />
                  <Flex gap="gap.smaller" className="mg-r-5">
                    <Button
                      primary
                      size="medium"
                      title={`${t("Participants.DoneAdding")}`}
                      content={`${t("Participants.DoneAdding")}`}
                      onClick={gotoRecipient}
                      disabled={recipients.length === 0 ? true : false}
                    />
                  </Flex>
                </Flex>
              </div>
            </Card>
          </Flex>
        </Provider> :
        <Provider
          theme={theme}
          className={`promoProvider paxSearchProvider appProvider`}
        >
          <Flex
            fill={true}
            column
            className="promoAppWrapper bg-none"
            style={{ paddingTop: "1%" }}
          >
            <Card>
              <div>
                <Text
                  className="bit_text_20 bit_text_bold bit_titleSpace"
                  key={"xLarge"}
                  variant={"xLarge" as ITextProps["variant"]}
                  nowrap
                  block
                >
                  {t("Behavior.CopyOthersHeader")}
                </Text>
                <div>
                  <div
                    className={`filter-icon ${filters && getFilterCount(filters) > 0
                      ? "advanced-filter-count-bg"
                      : ""
                      }`}
                    onClick={() => showModal(!isModalOpen)}
                  >
                    {filters && getFilterCount(filters) > 0 && (
                      <label>{getFilterCount(filters)}</label>
                    )}
                    <TooltipHost
                      content={t("Participants.AdvancedFilter.Filters")}
                      id={"tooltipId"}
                      calloutProps={{ gapSpace: 0 }}
                      styles={
                        filters && getFilterCount(filters) > 0
                          ? hostStyles1
                          : hostStyles
                      }
                    >
                      <div
                        className={`advanceFilter-icon-svg ${filters && getFilterCount(filters) > 0
                          ? "advanced-filter-white-icon"
                          : ""
                          }`}
                      ></div>
                    </TooltipHost>
                  </div>
                  <NormalPeoplePicker
                    onResolveSuggestions={onFilterChanged}
                    getTextFromItem={getTextFromItem}
                    pickerSuggestionsProps={suggestionProps}
                    className={"ms-PeoplePicker ms-Suggestions"}
                    key={"controlled"}
                    selectionAriaLabel={"Selected contacts"}
                    removeButtonAriaLabel="Remove"
                    selectedItems={copyOthersSelectedItem}
                    onChange={onCopyOthersChange}
                    inputProps={{
                      "aria-label": "Contacts",
                      "className": "ms-Suggestions max-width-list",
                      "placeholder": `${t("Participants.PlaceHolder")}`,
                      "onFocus": (ev: React.FocusEvent<HTMLInputElement>) => {
                        // console.log("onFocus called...", filterKey);
                        filterPersonasByText(filterKey);
                      },
                    }}
                    componentRef={picker}
                    resolveDelay={300}
                    disabled={isPickerDisabled}
                  />
                  <label className="label_gray">
                    {`${t("Participants.SubHeader")}`}
                  </label>
                  <section className="paxDefaultList">
                    {controlledItems.map((item, index) => (
                      <div key={index}>
                        <DefaultButton
                          styles={defaultButtonStyles}
                          onClick={() => {
                            setCopyOthersSelectedItem(
                              copyOthersSelectedItem.concat([item])
                            );
                          }}
                        >
                          <Persona {...item} />
                        </DefaultButton>
                      </div>
                    ))}
                  </section>
                </div>
              </div>
              <div className="footer">
                <Flex space="between">
                  <Button
                    icon={<ChevronStartIcon size="large" />}
                    tinted
                    iconOnly
                    title={`${t("Participants.Back")}`}
                    content={`${t("Participants.Back")}`}
                    onClick={event => copyOthersAdding("back")}
                    className="mg-l-5 bit-pad-10"
                    style={{ border: "1px #6264a7 solid" }}
                    size="medium"
                  />
                  <Flex gap="gap.smaller" className="mg-r-5">
                    <Button
                      primary
                      size="medium"
                      title={`${t("Participants.DoneAdding")}`}
                      content={`${t("Participants.DoneAdding")}`}
                      onClick={event => copyOthersAdding("add")}
                      disabled={recipients.length === 0 ? true : false}
                    />
                  </Flex>
                </Flex>
              </div>
            </Card>
          </Flex>
        </Provider>
      }
    </motion.div>
  );
};

function doesTextStartWith(text: string, filterText: string): boolean {
  return text.toLowerCase().indexOf(filterText.toLowerCase()) !== 0;
}

function removeDuplicates(
  personas: IPersonaProps[],
  possibleDupes: IPersonaProps[]
) {
  return personas.filter(
    (persona) => !listContainsPersona(persona, possibleDupes)
  );
}

function listContainsPersona(
  persona: IPersonaProps,
  personas: IPersonaProps[]
) {
  if (!personas || !personas.length || personas.length === 0) {
    return false;
  }
  return personas.filter((item) => item.text === persona.text).length > 0;
}

function convertResultsToPromise(
  results: IPersonaProps[]
): Promise<IPersonaProps[]> {
  return new Promise<IPersonaProps[]>((resolve, reject) =>
    setTimeout(() => resolve(results), 2000)
  );
}

function getTextFromItem(persona: IPersonaProps): string {
  return persona.text as string;
}

function getFilterCount(filter) {
  return Object.values(filter).filter((val) => val !== "").length;
}

export default PeoplePickerControlledExample;
